import React, { useEffect, useState } from "react";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import PageLayout from "../../../Components/Layout/PageLayout";
import {
  FormTemplate,
  FormSelectAlt,
  FormInputAlt,
  FormInput,
} from "../../../Components/Forms/InputTemplate";
import { FormProvider, useFieldArray, useForm } from "react-hook-form";
import {
  ActionButtons,
  SupportButtons,
} from "../../../../global/components/Buttons/buttons";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import RouteLayout from "../../../Components/Layout/RouteLayout";

import { FormatCurrency } from "../../../../../utils/functions/FormatCurrency";
import {
  GetRecommendations,
  UpdateRecommendation,
} from "../../../../../utils/redux/Finance/AnalyseCompanyFund/AnalyseCompanyFundSlice";
import { toast } from "react-toastify";
import { useGetAllAccountsQuery } from "../../../../api";

function RecommendEdit() {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { GlobalData, editMode } = useSelector((state) => state.companyFund);
  const { data: banks, isLoading } = useGetAllAccountsQuery({
    Search: "bank",
    PageSize: 10000,
    PageNumber: 1,
  });

  let editData = useSelector((state) =>
    state?.companyFund?.Recommendations?.result?.length
      ? state.companyFund.Recommendations.result[0]
      : {}
  );

  useEffect(() => {
    dispatch(
      GetRecommendations({
        pageSize: 10000,
        pageNumber: 1,
        ID: id,
      })
    );
  }, [dispatch]);

  const [selectedAccount, setSelectedAccount] = useState(null);
  const navigate = useNavigate();

  const formMethods = useForm({
    mode: "all",
  });

  const {
    handleSubmit,
    reset,
    formState: { isValid },
  } = formMethods;
  const fieldArray = useFieldArray({
    control: formMethods.control,
    name: "classSetups",
  });

  // Prepopulate form fields if in edit mode
  useEffect(() => {
    if (editMode && banks?.result) {
      const selectedBank = banks?.result?.find(
        (item) => item.id === editData?.ftLedgerId
      );
      setSelectedAccount(selectedBank);

      reset({
        bankID: editData?.ftLedgerId,
        balance: editData?.availableBalance,
        amount: editData?.investibleAmount,
      });
    }
  }, [editMode, banks, reset]);

  const RecommendInvestmentAmount = async (formData) => {
    const fmtData = {
      id: Number(id),
      ftLedgerId: selectedAccount?.id
        ? selectedAccount?.id
        : editData?.ftLedgerId,
      availableBalance: selectedAccount?.closingBal
        ? selectedAccount?.closingBal
        : editData?.availableBalance,
      investibleAmount: parseInt(formData?.amount),
      approvalStatus: 1,
    };

    if (fmtData.investibleAmount > fmtData.availableBalance) {
      toast.error(
        "Recommended Amount cannot exceed " + fmtData.availableBalance
      );
    } else {
      const response = await dispatch(UpdateRecommendation(fmtData)).then(
        (response) => {
          console.log({ response });
          if (response?.payload?.successful === true) {
            reset();
            navigate(-1);
          } else {
            toast.error(response?.payload?.statusMessage);
          }
        }
      );
    }
  };

  return (
    <RouteLayout title={"Finance"}>
      <PageLayout
        title={"Update Recommended Amount for Investment"}
        hasBack={true}
      >
        <FormProvider {...formMethods} {...fieldArray}>
          <FormTemplate
            className={DashboardStyle.view_app_components}
            handleSubmit={handleSubmit(RecommendInvestmentAmount)}
          >
            <section className={DashboardStyle.form_section}>
              <h4 className={`text-[#29382A] mt-5 text-[14px] font-[500]`}>
                Enter the required details
              </h4>

              <div className={DashboardStyle.inputs_group}>
                <div>
                  {/* Render a loading message if banks are still being fetched */}
                  {isLoading ? (
                    <div>Loading banks...</div>
                  ) : (
                    <FormSelectAlt
                      title={"Bank"}
                      camelCase={"bankID"}
                      placeholder={"Select Bank"}
                      isOptional={false}
                      array={banks?.result?.map((item, i) => (
                        <option
                          key={i}
                          value={item.ftLedgerId}
                          selected={
                            editData?.ftLedger?.accountNumber ===
                            item.accountNumber
                          }
                        >
                          {`${item.accountName}`}
                        </option>
                      ))}
                      moreRegister={{
                        onChange: (e) => {
                          let { value } = e.target;
                          let findValue = banks?.result?.find(
                            (item) => item.id === parseInt(value)
                          );
                          setSelectedAccount(findValue);
                        },
                      }}
                    />
                  )}

                  <FormInputAlt
                    title={"Available Balance"}
                    camelCase={"balance"}
                    placeholder={"0"}
                    isOptional={true}
                    disabled={true}
                    value={
                      selectedAccount?.closingBal || editData?.availableBalance
                    }
                  />
                </div>

                <div>
                  {/* <FormInput
                    title={"Amount"}
                    camelCase={"amount"}
                    placeholder={"Enter amount"}
                    isOptional={false}
                    value={editData?.investibleAmount} // Use defaultValue instead of value
                  /> */}

                  <input
                    type="number"
                    {...formMethods.register("amount", {
                      required: "Amount is required",
                    })}
                    placeholder={"Enter amount"}
                    defaultValue={editData?.investibleAmount}
                    className={DashboardStyle.input_field}
                    style={{
                      padding: "14px 20px 14px 20px",
                      gap: "16px",
                      borderRadius: "8px",
                      border: "1px solid #c4c4c4",
                      backgroundColor: "#F8FBF8",
                    }}
                  />
                </div>
              </div>
            </section>

            <div className={DashboardStyle.button_cage}>
              <SupportButtons
                onClick={() => {
                  reset();
                  navigate(-1);
                }}
                width={"auto"}
                className={DashboardStyle?.button_cage_weight}
              >
                Cancel
              </SupportButtons>

              <ActionButtons
                width={"auto"}
                className={DashboardStyle?.button_cage_weight}
              >
                Submit
              </ActionButtons>
            </div>
          </FormTemplate>
        </FormProvider>
      </PageLayout>
    </RouteLayout>
  );
}

export default RecommendEdit;
